import { lazy } from "react";
import { routeProps } from "Services/Share.props";
import RenderSubSection from "./RenderSubSections";
import Payments from "pages/Reporting/Payments";
import SaleDetail from "pages/Reporting/SaleDetail";
import Demand from "pages/Reporting/Demand";
import PdfFactor from "pages/Reporting/components/PdfFactor";
import AddNewPayment from "pages/Reporting/AddNewPayment";
import Discount from "pages/Reporting/Discount";

//TODO: ALL The pages become lazy import
const FinancialPeriod = lazy(() => import("pages/Reporting/FinancialPeriod"));

const financialPeriod = {
    name: "دوره مالی",
    path: "/financial-period-list",
    group: "financial-period-list",
    exact: true,
    component: (props: routeProps) => <FinancialPeriod {...props} />,
};
const financialPayments = {
    name: "دوره مالی",
    path: "/financial-payment-report/:periodID/:vendorID",
    group: "financial-payment-report",
    isHide: true,
    component: (props: routeProps) => <Payments {...props} />,
};

const financialSales = {
    name: "دوره مالی",
    path: "/financial-sale-report/:periodID/:vendorID",
    group: "financial-sale-report",
    isHide: true,
    component: (props: routeProps) => <SaleDetail {...props} />,
};

const financialDemand = {
    name: "دوره مالی",
    path: "/financial-demand-report/:periodID/:vendorID",
    group: "financial-demand-report",
    isHide: true,
    component: (props: routeProps) => <Demand {...props} />,
};

const financialDiscount = {
    name: "دوره مالی",
    path: "/financial-discount-report/:periodID/:vendorID",
    group: "financial-discount-report",
    isHide: true,
    component: (props: routeProps) => <Discount {...props} />,
};


const financialFactor = {
    name: "دوره مالی",
    path: "/financial-payment-factor",
    group: "financial-payment-factor",
    isHide: true,
    component: (props: routeProps) => <PdfFactor {...props} />,
};
const addNewPayment = {
    name: "دوره مالی",
    path: "/add-new-payment/:periodID/:vendorID",
    group: "add-new-payment",
    isHide: true,
    component: (props: routeProps) => <AddNewPayment {...props} />,
};

const subSections = {
    // main: {
    //     list: { ...reportingList },
    //     create: { ...createReport },
    //     update: { ...updateReport },
    //     view: { ...reportingView },
    //     upload: { ...uploadReport },
    // },
    financial: {
        list: { ...financialPeriod },
        create: { ...financialPayments },
        update: { ...financialSales },
        upload: { ...financialDemand },
        view:{...financialDiscount}
    },
    factor: {
        list: { ...financialFactor },
        create: { ...addNewPayment },
    },
};

const reportingSection = {
    title: "گزارشات",
    key: "reporting",
    SubRoutes: (keywords: any) => RenderSubSection(keywords, subSections),
};

export default reportingSection;
